/** The create page, opened from a starter goal on the empty Goals list. */
export type NewGoalSearch = {
  starter?: string;
};

/** The param as `validateSearch` receives it, unparsed. */
type UnvalidatedNewGoalSearch = {
  starter?: unknown;
};

/** Declared so the router keeps the param. A key no starter has is kept too: it is reported as given. */
export function validateNewGoalSearch(search: UnvalidatedNewGoalSearch): NewGoalSearch {
  return typeof search.starter === 'string' && search.starter !== '' ? { starter: search.starter } : {};
}
